var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 81);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  4: function _(e, t) {
    e.exports = require("../../utils/utils");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  81: function _(e, t, r) {
    "use strict";

    var n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    },
        o = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var l = n(r(1)),
        i = o(r(2)),
        u = n(r(5)),
        a = n(r(82)),
        c = r(3),
        s = r(4),
        f = c.colorPalettes.KineduPalette,
        d = i.default.span.attrs(function () {
      return {
        className: "label"
      };
    })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
      var e = _ref.theme;
      return e.label;
    }),
        m = i.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ", " {\n    ", ";\n  }\n\n\n  &:hover {\n    ", "\n\n    ", " {\n      ", ";\n    }\n  }\n"])), function (_ref2) {
      var e = _ref2.theme;
      return e.container;
    }, function (_ref3) {
      var e = _ref3.isActive,
          t = _ref3.theme;
      return e && t.isActiveContainer;
    }, d, function (_ref4) {
      var e = _ref4.isActive,
          t = _ref4.theme;
      return e && t.isActiveLabel;
    }, function (_ref5) {
      var e = _ref5.isDeletable,
          t = _ref5.theme;
      return e && t.containerHover;
    }, d, function (_ref6) {
      var e = _ref6.isDeletable,
          t = _ref6.theme;
      return e && t.labelHover;
    });

    t.default = function (_ref7) {
      var _ref7$theme = _ref7.theme,
          e = _ref7$theme === void 0 ? "Basic" : _ref7$theme,
          t = _ref7.label,
          r = _ref7.onClick,
          _ref7$isDeletable = _ref7.isDeletable,
          n = _ref7$isDeletable === void 0 ? !1 : _ref7$isDeletable,
          _ref7$isActive = _ref7.isActive,
          o = _ref7$isActive === void 0 ? !1 : _ref7$isActive,
          c = _ref7.iconName,
          p = _ref7.iconColor,
          b = _ref7.className,
          _ref7$onDelete = _ref7.onDelete,
          v = _ref7$onDelete === void 0 ? function () {} : _ref7$onDelete;
      return l.default.createElement(i.ThemeProvider, {
        theme: s.isObject(e) ? e : a.default[e]
      }, l.default.createElement(m, {
        onClick: r,
        isDeletable: n,
        isActive: o,
        className: "lego-tag " + b
      }, l.default.createElement(d, null, t), (c || n) && l.default.createElement(u.default, {
        onClick: function onClick(e) {
          v(), e.stopPropagation();
        },
        name: n ? "close" : c,
        size: n ? 14 : 20,
        color: p || f.shadeMediumDark
      })));
    };
  },
  82: function _(e, t) {
    e.exports = require("../../themes/Tag.theme");
  }
});